import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { RootStore } from "../root-store";
import { App, IconLocation } from "./app";
import { BaseModel } from "./base-model";
import { ProjectMember } from "./project-member";
import { User } from "./user";

export class Project extends BaseModel{
	color: string = "";
	name : string;
	description : string;
	surveyId : number;
	clientName: string;
	clientProjectName: string;
	clientNumber: string;
	testLinkDue: string;
	manager: string;
	purgeDate: string;

	@observable status: string;
	@observable userApps: UserApp[] = [];
	@observable projectAccess: ProjectAccess;

	constructor(data : any = {}, userapps: Array<any> = []) {
		super(data);
		this.fromJSON(data, userapps);
	}

	@computed get members(): ProjectMember[]{
		return _.orderBy(RootStore.projectMemberStore.findByProjectId(this.id), ["created"], ["desc"]);
	}

	@action fromJSON(data : any = {}, userApps: Array<any> = []){
		super.fromJSON(data);
		if(userApps.length > 0){
			for(let app of userApps){
				let details = {
					"id": app.id,
					"token": app.token,
					"disabled": app.disabled,
					"name": app.name
				}
				this.userApps.push(new UserApp(details));
			}
		}
		if (data) {
			this.projectAccess = data["access"];
			if(this.status){
				switch(this.status){
					case "New Project":
						this.color = "jibunu-blue";
						break;

					case "Configuration":
						this.color = "jibunu-pink";
						break;

					case "Programming":
						this.color = "jibunu-purple";
						break;

					case "In Production":
					case "Testing":
						this.color = "jibunu-orange";
						break;

					case "Live":
						this.color = "jibunu-green";
						break;

					case "Pretest":
						this.color = "jibunu-yellow";
						break;

					case "On Hold":
						this.color = "jibunu-gray";
						break;

					case "Closed":
						this.color = "jibunu-black";
						break;

					case "Internal":
						this.color = "jibunu-red";
						break;

					case "Purged":
					default:
						this.color = "jibunu-silver";
						break;
				}
			}
		}
	}


	@action async loadDemoApps(){
		let data = await Agent.Apps.all();
		runInAction(() => {
			data = _.filter(data, app => { return !(app.apiOnly || app.noDemo); });
			this.userApps = data.map(d => new UserApp(d));
		});
	}

	@action async loadMembers(){
		await RootStore.projectMemberStore.loadMembers(this.id);
	}

	@action async addMember(username: string){
		try{
			this.loading = true;
			let result = await Agent.Projects.addMember(this.id, username);
			await this.loadMembers();
			runInAction(() => {
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}

	@action async removeMember(pmId){
		await Agent.Projects.removeMember(this.id, pmId);
	}

	hasAccess(access: ProjectAccess){
		return (this.projectAccess & access) == access;
	}
}

export enum ProjectAccess{
	View							= 0,
	EditMembers				= 1 << 0,
}

export class UserApp extends BaseModel {
	token: string;
	disabled: boolean;
	name: string;

	constructor(data: any){
		super(data);
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/project.ts